import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeRegular, TitleLarge } from "../../../components/font";
import { Button, FileUploader, tokens } from "@manifesthhqinc/ui-library";

const AccountStatementUpload: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const {
    currentSourceAccountStep,
    onClickContinue,
    statementFile,
    handleUploadFile,
    uploadErrorMessage,
    isUploading,
    uploadedFiles,
    currentOldAccountDetails,
    handleRemoveFile,
  } = props;

  const shouldContinue =
    !isUploading &&
    (statementFile !== undefined || currentOldAccountDetails.sourceStatementFileNames.length > 0) &&
    uploadErrorMessage !== "Upload error: file must be <5MB" &&
    uploadErrorMessage !== "Upload error: invalid file type";

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <TitleLarge>Upload a recent statement from your old retirement account</TitleLarge>
            {currentOldAccountDetails.sourceStatementFileNames.length === 0 && (
              <BodyLargeRegular $color={tokens.color.text.secondary}>
                Log into your old provider account, type “Statement” into the search bar, and download your most recent
                quarterly statement.
              </BodyLargeRegular>
            )}
          </HeadingContainer>
          <FileUploader
            files={uploadedFiles}
            maxFiles={3}
            hasMultiple={false}
            onFileRemove={handleRemoveFile}
            onUploadFile={handleUploadFile}
            accept={{
              "application/pdf": [".pdf"],
              "image/jpeg": [".jpeg"],
              "image/jpg": [".jpg"],
              "image/png": [".png"],
              "image/heic": [".heic"],
              "image/heif": [".heif"],
            }}
            supportingText="Files must be less than 10MB. File types: 
.pdf, .jpeg, .jpg, .png, .heic."
          />
        </Container>
      </ScrollableContainer>
      {shouldContinue && (
        <Footer>
          <Button name="continueUploadStatement" onClick={onClickContinue} size="large">
            Continue
          </Button>
        </Footer>
      )}
    </TransitionWrapper>
  );
};

export default AccountStatementUpload;
